import React from "react";

import PropTypes from "prop-types";

import SEO from "../seo";

// eslint-disable-next-line import/prefer-default-export
export const GatsbyHead = ({ data: { page } }) => {
  const headerImage = page.elements.hero_image
    && page.elements.hero_image.value.length > 0
    && page.elements.hero_image.value[0].elements.image.value.length > 0
    ? page.elements.hero_image.value[0].elements.image.value
    : [];

  return (
    <SEO
      title={page.elements.metadata__meta_title.value}
      description={page.elements.metadata__meta_description.value}
      twitterTitle={page.elements.metadata__twitter_title.value}
      twitterSite={page.elements.metadata__twitter_site.value}
      twitterImage={page.elements.metadata__twitter_image.value.length > 0
        ? page.elements.metadata__twitter_image.value
        : headerImage}
      twitterDescription={page.elements.metadata__twitter_description.value}
      twitterCreator={page.elements.metadata__twitter_creator.value}
      ogTitle={page.elements.metadata__og_title.value}
      ogImage={page.elements.metadata__og_image.value.length > 0
        ? page.elements.metadata__og_image.value
        : headerImage}
      ogDescription={page.elements.metadata__og_title.value}
    />
  );
};

GatsbyHead.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
